import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Slider,
  Typography,
  FormControlLabel,
  Checkbox,
  Button,
  Paper,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { useTranslation } from "react-i18next";

const RISK_LEVEL_KEYS = [
  { value: 1, key: "riskLevels.veryLow" },
  { value: 2, key: "riskLevels.low" },
  { value: 3, key: "riskLevels.medium" },
  { value: 4, key: "riskLevels.high" },
  { value: 5, key: "riskLevels.veryHigh" },
];

export default function FilterPanel({ filters, setFilters, onReset }) {
  const { t } = useTranslation("export");

  const handleChange = (field) => (event) => {
    const value = event.target.value;
    setFilters((prev) => ({
      ...prev,
      [field]: value === "" ? undefined : value,
    }));
  };

  const handleAgeChange = (event, newValue) => {
    setFilters((prev) => ({
      ...prev,
      age_min: newValue[0],
      age_max: newValue[1],
    }));
  };

  const handleCheckboxChange = (field) => (event) => {
    setFilters((prev) => ({
      ...prev,
      [field]: event.target.checked ? true : undefined,
    }));
  };

  return (
    <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <FilterListIcon sx={{ mr: 1, color: "primary.main" }} />
        <Typography variant="h6">{t("filters.title")}</Typography>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "repeat(4, 1fr)" },
          gap: 3,
        }}
      >
        {/* Sex Filter */}
        <FormControl fullWidth size="small">
          <InputLabel>{t("filters.sex")}</InputLabel>
          <Select
            value={filters.sex || ""}
            label={t("filters.sex")}
            onChange={handleChange("sex")}
          >
            <MenuItem value="">{t("filters.all")}</MenuItem>
            <MenuItem value="Male">{t("filters.male")}</MenuItem>
            <MenuItem value="Female">{t("filters.female")}</MenuItem>
          </Select>
        </FormControl>

        {/* Risk Level Filter */}
        <FormControl fullWidth size="small">
          <InputLabel>{t("filters.riskLevel")}</InputLabel>
          <Select
            value={filters.risk_level ?? ""}
            label={t("filters.riskLevel")}
            onChange={handleChange("risk_level")}
          >
            <MenuItem value="">{t("filters.all")}</MenuItem>
            {RISK_LEVEL_KEYS.map((level) => (
              <MenuItem key={level.value} value={level.value}>
                {t(level.key)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Age Range */}
        <Box>
          <Typography variant="body2" gutterBottom>
            {t("filters.ageRange")}: {filters.age_min || 18} - {filters.age_max || 100}
          </Typography>
          <Slider
            value={[filters.age_min || 18, filters.age_max || 100]}
            onChange={handleAgeChange}
            valueLabelDisplay="auto"
            min={18}
            max={100}
            size="small"
          />
        </Box>

        {/* Has Recommendations */}
        <FormControlLabel
          control={
            <Checkbox
              checked={filters.has_recommendations === true}
              onChange={handleCheckboxChange("has_recommendations")}
              size="small"
            />
          }
          label={t("filters.hasRecommendations")}
        />
      </Box>

      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
        <Button
          variant="outlined"
          startIcon={<RestartAltIcon />}
          onClick={onReset}
          size="small"
        >
          {t("buttons.reset")}
        </Button>
      </Box>
    </Paper>
  );
}
